import React, { Component } from "react";

import { delay } from "@formant/core/common/delay";
import { duration } from "@formant/core/model/duration";

export class ScrollTo extends Component {
    private element?: HTMLElement;

    public async componentDidMount() {
        const { element } = this;
        if (!element) {
            return;
        }
        await delay(duration.second);
        element.scrollIntoView({
            block: "start",
            behavior: "smooth",
        });
    }

    public render() {
        return <div ref={_ => (this.element = _ || undefined)} />;
    }
}
